import CustomizationFunnel from './CustomizationFunnel.vue'

export default CustomizationFunnel
